'use client'

import { FC } from 'react'

import styles from './styles.module.css'
import { ButtonIconProps } from './types'

const ButtonIcon: FC<ButtonIconProps> = ({ className, icon, ...props }) => {
  return (
    <button className={`${styles.buttonIcon} ${className}`} {...props}>
      {icon}
    </button>
  )
}

export default ButtonIcon
